import React from 'react';

import LandingTranslater from 'components/shared/LandingTranslater';
import Loader from 'components/shared/Loader';
import Text from 'components/shared/Typography/Text';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { AGENT_PERMISSION_TRANSLATE_SERVICE, useIsSubscriptionAllowedExternal } from 'hooks/useIsSubscriptionAllowed';

import { ACCOUNT_TYPE_OWNER } from '../../../constants';
import ErrorScreen from '../../shared/ErrorScreen';
import { useRenderingKey } from '../ClientPortal/Itinerary/functions';
import { usePropertyPortal } from './functions';
import Page from './Page';

function PropertyPortal() {
  const { data, loading, error } = usePropertyPortal();
  useDocumentTitle({ title: 'Safari Portal' });

  if (error) {
    return <ErrorScreen status="404" />;
  }

  if (loading) {
    return <Loader isFillBlock />;
  }

  if (data) {
    return <InnerPropertyPortal data={data} />;
  }

  return <Text accent>Oops! Something went wrong</Text>;
}

export default PropertyPortal;

function InnerPropertyPortal({ data }) {
  const isTranslateAllowed = useIsSubscriptionAllowedExternal(
    data?.account,
    ACCOUNT_TYPE_OWNER,
    AGENT_PERMISSION_TRANSLATE_SERVICE,
  );

  const renderingKey = useRenderingKey();

  return (
    <>
      {isTranslateAllowed && (
        <LandingTranslater translationTrigger={renderingKey} translatableId={data.id} translatableType="page" />
      )}
      <Page key={renderingKey} data={data} />
    </>
  );
}
